import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

import {
  faLinkedin,
  faFacebookSquare,
  faTwitterSquare,
  faInstagramSquare,
  faFontAwesome
} from '@fortawesome/free-brands-svg-icons';

library.add(fas, faInstagramSquare, faFontAwesome);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">

        <div className="footer-col footer-brand">
          <p className="footer-logo">
            <span className="footer-logo-bracket">&lt;</span>
            MathBreakDown
            <span className="footer-logo-bracket">/&gt;</span>
          </p>
          <p className="footer-tagline">
            Master mathematics step by step with interactive exercises and clear explanations.
          </p>
          <address className="footer-address">
            <p>Helmond</p>
            <p>Netherlands</p>
            {/* <p>
              <a href="mailto:mathbreakdownapp@gmail.com">mathbreakdownapp@gmail.com</a>
            </p> */}
          </address>
        </div>

        <div className="footer-col footer-links">
          <h4 className="footer-col-title">Quick Links</h4>
          <ul className="footer-nav">
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/login">Login</Link></li>
          </ul>
        </div>

        {/* <div className="footer-col footer-social-col">
          <h4 className="footer-col-title">Follow Us</h4>
          <div className="footer-social-icons">
            <a href={"#linkedin"} className="icon-button linkedin" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faLinkedin} size="2x" color="#0e76a8"/>
              <span></span>
            </a>
            <a href={"#facebook"} className="icon-button facebook" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" color="#3b5998"/>
              <span></span>
            </a>
            <a href={"#instagram"} className="icon-button instagram" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagramSquare} size="2x" color="#c13584"/>
              <span></span>
            </a>
            <a href={"#twitter"} className="icon-button twitter" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faTwitterSquare} size="2x" color="#1da1f2"/>
              <span></span>
            </a>
          </div>
        </div> */}

      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} MathBreakDown. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
